module.exports = __webpack_public_path__ + "static/media/logoorange.5860f304.png";